//
//
//
//
//
//

export default {
    props:{
        show_add_group_img:Boolean,
        bottom_add_group_url:String
    }
}
